module.exports = __webpack_public_path__ + "static/media/vf_msneakers_core.4365d3e1.svg";